export interface IUser2FAConfiguration {
  appAuthenticator: any;
  createdBy: string;
  createdDate: Date;
  enabled: true;
  id: string;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  smsAuthenticator: ISmsAuthentication;
  typeEnabled: string;
  version: number;
  authorisationStatus: string;
}

interface ISmsAuthentication {
  createdBy: string;
  createdDate: Date;
  id: string;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  phoneNumber: string;
  version: number;
}

export interface IEnable2FAMethod {
  enabled: boolean;
  typeEnabled: string;
  version: number;
}

export interface ISmsAuthenticatorPatch {
  phoneNumber: string;
  version: number;
}

export interface IUser2FAConfigurationPost {
  enabled: boolean;
  smsAuthenticator: ISmsAuthenticatorPatch;
  typeEnabled: string;
}
